var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"environment"},[_vm._v(" "+_vm._s(_vm.getEnvironment == null ? '-' : _vm.getEnvironment)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }